import type { StoreSlugs } from '@iheartjane/data-access';
import { Flex, Tag, Typography } from '@iheartjane/reefer';

import type { BloomStore } from '@jane/business-admin/types';
import { generateStoreUrl } from '@jane/business-admin/util';

import { CopyLink } from './CopyLink';

import styles from './storeSection.module.css';

export const StoreSection = ({
  store,
  menuUrl,
  storeSlugs,
}: {
  menuUrl: string;
  store: BloomStore;
  storeSlugs?: StoreSlugs;
}) => {
  const storeAddress = `${store.address}, ${store.city}, ${store.state} ${store.zip}`;
  const storeUrl = generateStoreUrl(menuUrl, store.id, storeSlugs);

  return (
    <Flex className={styles['section']} flexDirection="row" p={24}>
      <Flex alignItems="center">
        <Tag
          label={store.recreational ? 'Rec' : 'Med'}
          color={store.recreational ? 'purple' : 'palm-dark'}
          background={store.recreational ? 'purple-light' : 'palm-light'}
        />
      </Flex>

      <Flex flexDirection="column" ml={24} width="100%">
        <Typography variant="body-bold">{store.name}</Typography>
        <Typography color="grays-mid">{storeAddress}</Typography>
        <Typography color="grays-mid">{storeUrl}</Typography>
      </Flex>
      <Flex mt={8} alignItems="flex-end" justifyContent="flex-end" width="100%">
        <CopyLink
          ariaLabel="Copy store url"
          iconSize="sm"
          label="Copy link"
          value={storeUrl}
        />
      </Flex>
    </Flex>
  );
};
